import { isAllTenants } from '@/config/tenant.config';
import { localSource } from '@/datasource/local/localSource';

/** When header tenant is "all", knowledge tabs override x-tenant-id for knowledge/persona APIs only. */
let knowledgeTenantOverride: string | null = null;

export function setKnowledgeTenantOverride(tenantId: string | null): void {
  knowledgeTenantOverride = tenantId?.trim() || null;
}

export function clearKnowledgeTenantOverride(): void {
  knowledgeTenantOverride = null;
}

/** Global admin scope — users, guests, dashboard, etc. Never applies knowledge tab override. */
export function resolveAdminTenantHeader(): string {
  return localSource.getTenantId();
}

/** Knowledge/persona APIs when header scope is "all tenants". */
export function resolveKnowledgeTenantHeader(): string {
  const headerTenant = localSource.getTenantId();
  if (!isAllTenants(headerTenant)) return headerTenant;
  return knowledgeTenantOverride ?? headerTenant;
}

export function isKnowledgeTenantRequest(url: string | undefined): boolean {
  if (!url) return false;
  return url.includes('/admin/knowledge') || url.includes('/admin/persona');
}
